import moment from "moment";
import { AdminApi } from "../../service";

export function logAdminRoute(path: string) {
  return AdminApi.post(
    `log/admin/route`, 
    {
      path,
      timestamp: moment().unix()
    }
  );
}

export function logExport(reason: string, dataType: string, count: number) {
  return AdminApi.post(
    `log/admin/export`,
    {
      reason,
      dataType,
      count,
      timestamp: moment().unix()
    }
  );
}